export enum UserRoles {
  User = 'user',
  Admin = 'admin',
  HiringManager = 'hiring_manager',
  Manager = 'manager',
  Recruiter = 'recruiter',
}
